import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { appLink } from '@app/config/appLink'
import { GuideCard } from '@app/modules/GuideV2/components/GuideCard'
import { useNavigate } from 'react-router-dom'
import SectionContent from '../../../../src/components/SectionContent'
import SectionHeading from '../../HomeV2/components/SectionHeading'
import { guideContentTypes } from '../config/guide.config'
import { useRecentArticles } from '../hooks/useRecentArticles'
import { GuideCardSkeleton } from './GuideCardSkeleton'

export const GuideRecentArticles = () => {
  const { data: articles = [], isLoading } = useRecentArticles()
  const navigate = useNavigate()

  return (
    <div className="py-2">
      <SectionContent>
        <SectionHeading>Recent articles</SectionHeading>
        <Carousel opts={{ align: 'start', loop: false }} className="w-full max-w-5xl mx-auto">
          <CarouselContent className="-ml-4">
            {isLoading
              ? Array.from({ length: 3 }).map((_, index) => (
                  <CarouselItem key={index} className="pl-4 md:basis-1/2 lg:basis-1/3">
                    <GuideCardSkeleton />
                  </CarouselItem>
                ))
              : articles.map((article) => (
                  <CarouselItem key={article.id} className="pl-4 md:basis-1/2 lg:basis-1/3">
                    {(() => {
                      const rawType = article.sub_tabs?.[0]?.main_topic?.slug
                      const articleType = guideContentTypes.includes(
                        rawType as (typeof guideContentTypes)[number],
                      )
                        ? (rawType as (typeof guideContentTypes)[number])
                        : undefined

                      return (
                        <GuideCard
                          title={article.title}
                          description={article.description ?? ''}
                          type={articleType}
                          onActionClick={() => {
                            const mainTopicSlug = article.sub_tabs?.[0]?.main_topic?.slug
                            const subTabSlug = article.sub_tabs?.[0]?.slug

                            navigate(
                              `${appLink.guidePage.path}/${mainTopicSlug}/${subTabSlug}/${article.slug}`,
                            )
                          }}
                        />
                      )
                    })()}
                  </CarouselItem>
                ))}
          </CarouselContent>
          <CarouselPrevious className="-left-4 lg:-left-10 rounded-md" size={'icon'} />
          <CarouselNext className="-right-4 lg:-right-10 rounded-md" size={'icon'} />
        </Carousel>
      </SectionContent>
    </div>
  )
}
